"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderDateOrFallback = exports.renderDate = exports.renderBoolean = exports.LS_DATE_FORMAT = void 0;
const moment_1 = __importDefault(require("moment"));
exports.LS_DATE_FORMAT = 'MMMM Do YYYY, h:mm a';
const renderBoolean = (criteria) => (criteria ? 'TRUE' : 'FALSE');
exports.renderBoolean = renderBoolean;
const renderDate = (date, formatStr = exports.LS_DATE_FORMAT) => {
    return (0, moment_1.default)(date).format(formatStr);
};
exports.renderDate = renderDate;
const renderDateOrFallback = (date, fallback, format) => date ? (format ? (0, exports.renderDate)(date, format) : (0, exports.renderDate)(date)) : fallback;
exports.renderDateOrFallback = renderDateOrFallback;
//# sourceMappingURL=dates.js.map